module.exports = __webpack_public_path__ + "img/img52.7f91be71.png";